import { useClient } from "../../api/useClient";
import { AppCard, AppCardPublished } from "../../components/types";

export function useAppCard(appId: string): [AppCard, AppCardPublished | null] {
    const client = useClient();
    const result = client.useGetAppCard({ appId }, { fetchPolicy: "network-only" });
    return [result.app.card, result.app.publishedCard];
}